import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector, useDispatch } from 'react-redux';
import { loadUser, updatePaymentFailedRetry } from '../../actions/userActions'
import { useHistory } from 'react-router';
import { url } from '../../config';
import { FormattedMessage, useIntl } from "react-intl";


function LogOutModal(props) {
  const [showModal, setShowModal] = useState(true);


  return (
    <div className="container mt-5 demo-one11">
      {showModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" style={{ borderRadius: '15px' }}>
                <div className="modal-body text-center p-4" style={{ backgroundColor: 'white', borderRadius: '10px' }}>
                 

                  <p className="text-muted mb-4" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    <FormattedMessage id="PaymentReNewMain" defaultMessage="PaymentReNewMain" />
                  </p>

             
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default LogOutModal